import { atom } from "jotai";

import { AccessYourAccountStep } from "../../../types";
import {
  VerificationModalStepStateAtom,
  VerificationModalTrackEventAtom,
} from "../../stores";

export const ProceedToAccessYourAccountStepAtom = atom(
  null,
  (get, set, { emailOrPhone }: { emailOrPhone: string }) => {
    const track = get(VerificationModalTrackEventAtom);
    const nextStep: AccessYourAccountStep = {
      step: "AccessYourAccount",
      backStep: "ClubSelection",
      emailOrPhone,
    };
    set(VerificationModalStepStateAtom, nextStep);
    track?.("AuthModal.AccessYourAccountStep", nextStep);
  }
);
